export default "__VITE_ASSET__9cc18e6e__"